<script setup>
import GenericCard from "@/components/ui/card/GenericCard.vue";
import { Badge } from "@/components/ui/badge";

const planRecommendations = [
    {
        serialNumber: 1,
        title: "You're a cooperative union",
        recommendation: 'Enterprise',
        description: 'Coordinate multiple hubs with role-based access control',
    },
    {
        serialNumber: 2,
        title: 'You run a single farmers market',
        recommendation: 'Standard',
        description: 'Perfect for tracking one location with buyers and suppliers',
    },
    {
        serialNumber: 3,
        title: 'You operate 3+ markets across different locations',
        recommendation: 'Enterprise',
        description: 'Get consolidated views and manage staff across all locations',
    },
];
</script>

<template>
    <div class="flex flex-col gap-4">
        <GenericCard v-for="planRecommendation in planRecommendations" :key="planRecommendation.serialNumber">
            <template #header>
                <div class="flex flex-col justify-start items-start">
                    <div class="flex flex-row justify-start gap-4">
                        <div class="hidden md:flex rounded-full w-8 h-8 p-3 flex justify-center items-center text-center text-xs font-medium text-white bg-primary-green">
                            {{ planRecommendation.serialNumber }}
                        </div>
                        <div class="flex flex-col justify-start">
                            <div class="text-lg font-medium text-primary-font mb-3">{{ planRecommendation.title }}</div>
                            <div class="flex flex-row justify-start items-center gap-2 font-medium mb-2">
                                <div class="text-base text-primary-gray">
                                    Recommendation:
                                </div>
                                <Badge class="text-sm text-white bg-primary-green rounded-xl">
                                    {{ planRecommendation.recommendation }}
                                </Badge>
                            </div>
                            <div class="text-base text-primary-gray">{{ planRecommendation.description }}</div>
                        </div>
                    </div>
                </div>
            </template>
        </GenericCard>   
    </div>
</template>